export default __webpack_public_path__ + "static/media/w1.405a1ca7.png";